import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";

const initState = {
  isLogin: window.fjuser && window.fjuser.isUserLogin(),
  projectName: FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME),
  videoEditor: FJCanvasStore.executeSync(FJCanvasStore.command.GET_VIDEO_EDITOR),
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_LOGIN_STATUS:
      return {
        ...state,
        isLogin: action.isLogin,
      };
    case FJActionConstant.UPDATE_PROJECT_NAME:
      return {
        ...state,
        projectName: action.data,
      };
    case FJActionConstant.UPDATE_EDITOR_NAME:
      return {
        ...state,
        videoEditor: action.videoEditor,
      };
    default:
      return state;
  }
}
